<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "EximCeisaHsCode",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  